export const INSURER_MIN_AGE = 17;
